

import { StaticAttrsMixin } from "@/mixins/class-attr";
import { Component, Prop, Mixins } from "vue-property-decorator";
import { IObjectAnyKeyVal } from "@/models/common";
import TestProps from "@/mixins/test/TestProps";

@Component
export default class IBButton extends Mixins(
	StaticAttrsMixin,
	TestProps
) {

	@Prop(String)
	readonly iconImg: string | undefined;

	@Prop(String)
	readonly prependIcon: string | undefined;

	@Prop(String)
	readonly appendIcon: string | undefined;

	@Prop({ type: Boolean, default: false })
	readonly secondary!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly large!: boolean;

	@Prop({ type: String, default: 'button' })
	readonly type!: string;

	@Prop(Boolean)
	readonly outlined?: boolean;

	@Prop(Boolean)
	readonly rounded?: boolean;

	@Prop(Number)
	readonly version?: number;

  @Prop({ type: Boolean, default: false })
  readonly useImg!: boolean;

	public classObj: IObjectAnyKeyVal;

	constructor() {
		super();

		this.classObj = {
			icon: !!this.iconImg && !this.useImg,
			btn: true,
			"append-icon": !!this.appendIcon,
			large: this.large,
			secondary: this.secondary,
			outlined: this.outlined,
			rounded: this.rounded,
			[`version-${this.version}`]: !!this.version,
			...this.staticClass
		};

	}

	onClick() {
		this.$emit("click");
	}

  onAppendIconClick(event: MouseEvent): void {
    event.stopPropagation();
    this.$emit('appendIconClick');
  }

	get hasDefaultSlot() {
		return !!this.$slots.default;
	}

}

